<template>
  <div v-if="paazlDate" v-auto-animate class="my-2">
    <div
      v-if="
        paazlStore.hasTomorrowDelivery || paazlStore.hasDayAfterTomorrowDelivery
      "
      class="relative flex min-h-12 w-full items-center gap-4 bg-gray-ultralight/60 px-4 py-1"
    >
      <div class="flex items-center gap-4">
        <TruckIcon />
        <span class="flex flex-col">
          <span v-if="paazlDate" class="block" v-html="paazlDate" />
          <span
            v-if="paazlDescription && paazlStore.hasTomorrowDelivery"
            class="text-xs italic"
            v-text="paazlDescription"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TruckIcon from '@/components/Icons/TruckIcon.vue';
import { usePaazlStore } from '@/stores/Paazl/PaazlStore.ts';

const paazlStore = usePaazlStore();

defineProps({
  paazlDate: {
    type: String,
    required: false,
    default: undefined,
  },

  paazlDescription: {
    type: String,
    required: false,
    default: undefined,
  },
});
</script>
